<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Z0TwrX/tc-custom/9781504065993.jpg?1737055752917" alt="This image is the cover for the book Coffins for Two"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Coffins for Two
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Eighteen Golden Age stories of mystery, romance, and danger from the celebrated author of <i>Murder in Peking</i> and <i>The Private Life of Sherlock Holmes</i>.</b></p><p>As he tries to reunite with the woman he loves, an escaped fugitive becomes enveloped in a game of cat and mouse with the policeman who put him away. An undertaker and his assistant discover a potion of almost magical proportions. A young woman hatches an elaborate plot to get her suitors institutionalized. A professional golfer becomes infatuated with another man’s wife. A short story writer finds an unusual way to work out his next idea while riding public transportation.</p> Although Vincent Starrett went on to write successful mystery novels, he continued creating tales like these for pulp magazines in the 1920s and 30s. “The Fugitive,” “The Elixir of Death,” “Four Friends of Mavis,” “The End of the Story,” and “The Truth About Delbridge” are just a sampling of the fantastic and bizarre stories featured in this volume, some exhibiting a sense of humor, others irony or terror.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vincent Starrett
      </h2>
      
      <p class="authorDescription body article">Vincent Starrett (1886&ndash;1974) was a Chicago journalist who become one of the world&rsquo;s foremost experts on Sherlock Holmes. A books columnist for the <I>Chicago Tribune</I>, he also wrote biographies of authors such as Robert Louis Stevenson and Ambrose Bierce. A founding member of the Baker Street Irregulars, Starrett is best known for writing <I>The Private Life of Sherlock Holmes</I> (1933), an imaginative biography of the famous sleuth.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6cd9e2b6